import { uploadValidation } from './schemas/uploadValidation';
import apiClient from './apiClient';
import UploadValidationDataStore from '@/data/datastores/UploadValidationDataStore';

class UploadValidationDataStoreGraphQL implements UploadValidationDataStore {
  async uploadValidation(imgBase64: string) {
    try {
      const client = apiClient();
      const response = await client.mutate({
        mutation: uploadValidation,
        variables: { imgBase64 }
      });
      return response.data?.uploadValidation;
    } catch (error) {
      throw new Error('error uploadValidation');
    }
  }
}

export default UploadValidationDataStoreGraphQL;
